import {get, post, put, destroy} from './config';

const Directory = {
  addCategory: (data) =>
    post('v1/directories/cargo/categories', data),
  addPrivateCategory: (data) =>
    post('v1/directories/cargo/categories/private', data),
}

export default Directory;
